import type { FC } from 'react';
import { memo } from 'react';
import { useTranslation } from 'next-i18next';
import { selectSportFavoritesSetV2, useLineMarketsColumnGroup, useSortLineMarkets } from '@mwl/core-lib';
import { MarketBlock } from '@/components/MarketBlock/MarketBlock';
import { useMediaWidthDown, useTypedSelector } from '@/hooks';
import { AcceptanceBetsStopped } from '../AcceptanceBetsStopped/AcceptanceBetsStopped';
import type { AcceptanceBetsStoppedClasses } from '../AcceptanceBetsStopped/AcceptanceBetsStopped.types';
import type { MarketsProps } from './Markets.types';
import styles from './Markets.module.scss';
const pauseAlertClasses: AcceptanceBetsStoppedClasses = {
  content: styles.pausedAlertContent
};
const BaseMarkets: FC<MarketsProps> = ({
  lineId,
  isPaused,
  isFinished,
  markets,
  className,
  activeFilter,
  variant,
  lineStage,
  category,
  championships,
  matchId,
  sportCategory
}) => {
  const {
    t
  } = useTranslation('sport');
  const isSmallScreen = useMediaWidthDown('screen850');
  const favorites = useTypedSelector(selectSportFavoritesSetV2);
  const isOutrightLine = variant === 'OUTRIGHT';
  const sortedMarkets = useSortLineMarkets(markets);
  const marketColumns = useLineMarketsColumnGroup({
    markets: sortedMarkets,
    activeFilter,
    isSmallScreen,
    variant
  });
  return <div className={cn(styles.root, variant && styles[variant.toLowerCase()], className)} data-sentry-component="BaseMarkets" data-sentry-source-file="Markets.tsx">
      {(!isFinished || isOutrightLine) && <div className={cn(styles.content, {
      [styles.paused]: isPaused
    })}>
          {marketColumns.map((column, index) => <div className={styles.marketColumn} key={index}>
              {column.map((market, idx) => {
          const marketOutcomes = (market.outcomes ?? []).filter(odd => odd?.status === 'OPENED' || odd?.status === 'PAUSED');
          if (!marketOutcomes.length) {
            return null;
          }
          return <MarketBlock key={`${lineId}-${market.id}-${idx}`} outcomes={marketOutcomes} lineId={lineId} lineStage={lineStage} linePaused={isPaused} marketId={market.id} marketTitle={market.title} isFavorite={favorites.marketIds.has(market.id)} variant={variant} description={market.description} category={category} championships={championships} matchId={matchId} sportCategory={sportCategory} />;
        })}
            </div>)}
        </div>}

      {isPaused && !isFinished && !isOutrightLine && <AcceptanceBetsStopped className={styles.pausedAlert} classes={pauseAlertClasses}>
          {t('acceptance_bets_paused', 'Accepting bets is suspended')}
        </AcceptanceBetsStopped>}

      {isFinished && !isOutrightLine && <AcceptanceBetsStopped>{t('acceptance_bets_stopped', 'Acceptance of bets is stopped')}</AcceptanceBetsStopped>}
    </div>;
};
export const Markets = memo(BaseMarkets);
Markets.displayName = 'Markets';